// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___d2px5","top":"top___oPOo_","message":"message____vwT3","confirmMessage":"confirmMessage___mTiCu","links":"links___rIo4a","submit":"submit___nvGZz"};